import React, { useEffect, useMemo, useRef, useState } from 'react';
import { sortCountriesByPriority } from '../constants/countryPriority';

export default function CountrySearchSelect({
  countries = [],
  value,
  onChange,
  required = false,
  placeholder = 'Type to search country...',
  disabled = false,
}) {
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  const sortedCountries = useMemo(
    () => sortCountriesByPriority(countries.filter(c => c.status === 'Active' || !c.status)),
    [countries]
  );

  const selected = sortedCountries.find((c) => String(c.id) === String(value));

  useEffect(() => {
    if (selected) setQuery(selected.country_name || '');
    else if (!value) setQuery('');
  }, [value, selected]);

  useEffect(() => {
    const close = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  const term = query.toLowerCase().trim();
  const filtered = sortedCountries.filter((c) => {
    if (!term) return true;
    return (c.country_name || '').toLowerCase().includes(term);
  });

  return (
    <div ref={wrapRef} style={{ position: 'relative' }}>
      <input
        type="text"
        className="input-field"
        placeholder={placeholder}
        value={query}
        disabled={disabled}
        onChange={(e) => {
          setQuery(e.target.value);
          setOpen(true);
          if (value) onChange('');
        }}
        onFocus={() => !disabled && setOpen(true)}
        autoComplete="off"
        required={required && !value}
      />
      {open && !disabled && (
        <div style={{
          position: 'absolute', zIndex: 20, top: '100%', left: 0, right: 0,
          background: 'white', border: '1px solid #e5e7eb', borderRadius: '8px',
          maxHeight: '260px', overflowY: 'auto', boxShadow: '0 8px 20px rgba(0,0,0,0.08)',
          marginTop: '4px'
        }}>
          {filtered.length === 0 ? (
            <div style={{ padding: '12px 14px', color: '#6b7280', fontSize: '13px' }}>No countries found</div>
          ) : filtered.map((c) => (
            <button
              key={c.id}
              type="button"
              onMouseDown={(e) => {
                e.preventDefault();
                onChange(String(c.id));
                setQuery(c.country_name || '');
                setOpen(false);
              }}
              style={{
                display: 'block', width: '100%', textAlign: 'left', border: 'none',
                background: String(c.id) === String(value) ? '#fff7ed' : 'white',
                padding: '10px 14px', cursor: 'pointer', fontSize: '13px',
                fontWeight: String(c.id) === String(value) ? 600 : 400,
                color: String(c.id) === String(value) ? '#c2440e' : '#111827'
              }}
            >
              {c.country_name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
